import { useSelector } from 'react-redux';
import type { VoidFunctionComponent } from 'react';

import { plural } from '../../../../../shared/helpers/plural';
import * as IssuesV2Store from '../../../../redux/issuesV2';
import { Icon, regularIcons } from '../../../generic';
import { formatDate } from './utils';

import sharedStyles from '../IssueDetails.module.less';
import styles from './IssueDetailsStatus.module.less';
import { UserEmail } from './UserEmail';

/**
 * Display the issue details status in the release group scope.
 */
export const ReleaseGroupStatus: VoidFunctionComponent = () => {
  const activeCount = useSelector(IssuesV2Store.selectors.getActiveIssueCount);
  const ignoredCount = useSelector(IssuesV2Store.selectors.getIgnoredIssueCount);
  const ticketedCount = useSelector(IssuesV2Store.selectors.getTicketedIssueCount);

  const releaseGroup = useSelector(IssuesV2Store.selectors.getIssueReleaseGroup);
  const ignoredBy = releaseGroup?.ignoredBy;
  const ignoredAt = releaseGroup?.ignoredAt;
  const ignoredByText = ignoredBy ? (
    <span>
      by <UserEmail userEmail={ignoredBy} />{' '}
    </span>
  ) : (
    ''
  );

  return (
    <div className={styles.globalIssueDetailsStatus}>
      {activeCount > 0 && (
        <span>
          <span className={`${sharedStyles.icon} ${sharedStyles.activeIcon}`}>
            <Icon icon={regularIcons.exclamationCircleRegular} />
          </span>
          <span className="bold">Active</span> in {activeCount} {plural(activeCount, 'project')}
        </span>
      )}
      {ignoredCount > 0 && (
        <span>
          <span className={`${sharedStyles.icon} ${sharedStyles.ignoredIcon}`}>
            <Icon icon={regularIcons.eyeSlashRegular} />
          </span>
          <span className="bold">Ignored</span> in {ignoredCount} {plural(ignoredCount, 'project')} {ignoredByText}
          {formatDate(ignoredAt)}
        </span>
      )}
      {ticketedCount > 0 && (
        <span>
          <span className={`${sharedStyles.icon} ${sharedStyles.ticketedIcon}`}>
            <Icon icon={regularIcons.ticket} />
          </span>
          <span className="bold">Ticketed</span> in {ticketedCount} {plural(ticketedCount, 'project')}
        </span>
      )}
    </div>
  );
};
